import { render, staticRenderFns } from "./outer-chain.vue?vue&type=template&id=171d2a08&scoped=true"
import script from "./outer-chain.ts?vue&type=script&lang=ts&external"
export * from "./outer-chain.ts?vue&type=script&lang=ts&external"
import style0 from "./outer-chain.scoped.scss?vue&type=style&index=0&id=171d2a08&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d2a08",
  null
  
)

export default component.exports